import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Okay publishers, I get the hint, nonacademics shouldn't cite original sources",
  "description": "",
  "published": "2013-07-15T00:00:00.000Z",
  "redirect_from": ["/blog/okay-publishers-i-get-the-hint-nonacademics-shouldnt-cite-original-sources/swizec/6276"],
  "categories": "Cognition, Energy, Energy level, Physical exercise, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/B556uUtqTkyDg4jyZvHr",
        "alt": "Academics"
      }}></img></p>
    <p>{`For the past few days I've been trying to find a measurable definition for `}<em parentName="p">{`"energy levels"`}</em>{`. Not in terms of physics, but in terms of `}<em parentName="p">{`"Today I just don't have the energy to work."`}</em>{`, or `}<em parentName="p">{`"I always get so sleepy after lunch and can't get anything done"`}</em>{`.`}</p>
    <p>{`Everyone knows their energy levels fluctuate through the day, but that's not good enough. For `}<a parentName="p" {...{
        "href": "http://leanpub.com/nightowls"
      }}>{`Why programmers work at night`}</a>{`, I wanted to find `}<em parentName="p">{`what`}</em>{` these mythical energy levels are exactly.`}</p>
    <p>{`The term I was looking for was `}<em parentName="p">{`"mental energy"`}</em>{`.`}</p>
    <p>{`Excitement abounds! After days of fussing, I finally know what to search for!`}</p>
    <p>{`Giddily I discovered research on mental energy is alive and busy. A lot of articles published in the last few years, all of them looking very relevant to what I'm interested in.`}</p>
    <p>{`But I think scientific `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Publishing",
        "title": "Publishing"
      }}>{`publishers`}</a>{` don't want me to cite `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Research",
        "title": "Research"
      }}>{`original research`}</a>{` in my work. Can anything else explain the ridiculous paywalls they have in place?`}</p>
    <p>{`Out of some 20 interesting articles I found, only six had free pdf's available online. And of those, only two or three were easily available.`}</p>
    <p>{`After numerous citation pages with nothing more than an abstract posted, I have culled my list down to four really great sounding articles with the total cost of $207. `}{`*`}{`*`}{`$207 for 4 articles.`}{`*`}{`*`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://informahealthcare.com/doi/abs/10.1080/00207450802333995"
        }}>{`Sensitivity to Change in Cognitive Performance and Mood Measures of Energy and Fatigue in Response to Differing Doses of Caffeine or Breakfast `}</a>{`- `}<strong parentName="li">{`\\`}{`\\`}{`\\`}{`\\`}{`$86 for 19 pages`}</strong></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ingentaconnect.com/content/maney/nns/2007/00000010/f0020005/art00005"
        }}>{`Cognitive methods for assessing mental energy`}</a>{` - `}<strong parentName="li">{`\\`}{`\\`}{`\\`}{`\\`}{`$48 for 14 pages`}</strong></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.sciencedirect.com/science/article/pii/S0160289605000279"
        }}>{`Mental Energy`}</a>{` - `}<strong parentName="li">{`\\`}{`\\`}{`\\`}{`\\`}{`$31 for 4 pages`}</strong></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://onlinelibrary.wiley.com/doi/10.1111/j.1753-4887.2001.tb06995.x/abstract"
        }}>{`The Effects of Ginseng, Ephedrine, and Caffeine on Cognitive Performance, Mood and Energy`}</a>{` - `}<strong parentName="li">{`\\`}{`\\`}{`\\`}{`\\`}{`$42 for 4 pages`}</strong></li>
    </ul>
    <p>{`$6.5 per page on average.`}</p>
    <p><em parentName="p">{`\\`}{`\\`}{`\\`}{`\\`}{`$6.5 per page`}</em>{`!`}</p>
    <p>{`I understand these publishers have small sales volumes, but this is beyond ridiculous. Who even buys these things? Universities?`}</p>
    <p>{`That's nice I guess. But I'm not part of a university. I'm writing the book independently and on a shoe-string budget. But I am not welcome in the ivory tower of academia.`}</p>
    <p>{`Keep this in mind next time you complain about the poor state of scientific reporting in the media.`}</p>
    <p>{`Outsiders are not welcome.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=04f6efe8-67bb-4a5c-a4c1-43aac378e077",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      